var map = {
	"./All Animal Video Version 1.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/All Animal Video Version 1.webm",
	"./Bear.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Bear.webm",
	"./Buff.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Buff.webm",
	"./Cat.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Cat.webm",
	"./Credit Video Version 1.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Credit Video Version 1.webm",
	"./Crock.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Crock.webm",
	"./Deer.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Deer.webm",
	"./Duck.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Duck.webm",
	"./Elephant.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Elephant.webm",
	"./Head To Toe Final Compressed Version m4v.mp4": "./src/EGRContent/Story/MaPaniSakchu/movies/Head To Toe Final Compressed Version m4v.mp4",
	"./Horse.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Horse.webm",
	"./Hyena.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Hyena.webm",
	"./Intro.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Intro.webm",
	"./Leopard.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Leopard.webm",
	"./Lion.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Lion.webm",
	"./Monkey.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Monkey.webm",
	"./Okapi.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Okapi.webm",
	"./Owl.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Owl.webm",
	"./Panda.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Panda.webm",
	"./Rabbit.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Rabbit.webm",
	"./Rhino.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Rhino.webm",
	"./Salak.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Salak.webm",
	"./Spider.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Spider.webm",
	"./Tiger.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Tiger.webm",
	"./Wolf.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Wolf.webm",
	"./Yak.webm": "./src/EGRContent/Story/MaPaniSakchu/movies/Yak.webm"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/MaPaniSakchu/movies sync recursive ^\\.\\/.*$";